module.exports = __webpack_public_path__ + "img/电商.059b94e6.svg";